<div *ngIf="error" class="alert alert-warning">
  {{error}}
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <p i18n="@@addBank.iban.infoLabel" class="text-gray text-sm">Please fill in the details below and we will locate your full bank using a partner service.</p>
  <form-field label="IBAN" i18n-label="@@addBank.iban.label">
    <input type="text" formControlName="iban" placeholder="Enter IBAN" i18n-placeholder="@@addBank.iban.placeholder">
  </form-field>

  <form-field label="Account Holder Name" i18n-label="@@addBank.bankName.accountHolderLegalName">
    <input type="text" formControlName="accountHolderLegalName" placeholder="Enter full legal account holder name" i18n-placeholder="@@addBank.accountHolderLegalName.placeholder">
  </form-field>

  <div class="w-100 d-flex flex-column align-items-center">  
    <button type="submit" class="btn btn-block btn-primary" [disabled]="!form.valid || loading">
      <ng-container *ngIf="loading" i18n="@@addBank.submitLoading">Loading...</ng-container>
      <ng-container *ngIf="!loading" i18n="@@addBank.continue">Continue</ng-container>
    </button>
  </div>
</form>
